module.exports = __webpack_public_path__ + "static/media/GUESS.bf107df9.svg";